<template lang="pug">
.customer-short-detail-button
  button.transparent-button.no-scaling.w-100.d-flex.p-3(@click="$emit('click')")
    CustomerPicture(:src='data.image' :grade='data.grade')
    .flex-fill.text-left.ml-3
      .h6.mb-0.mt-1
        | {{ data.name }}
      .font-weight-normal.text-secondary
        small ยอดซื้อสะสม
      .h5.text-danger
        | {{ data.total | currency }}

  hr.my-0.mx-3

  //- .d-flex.mx-3
  //-   button.transparent-button.w-50.py-2(@click='showPhone')
  //-     i.fa.fa-phone.mr-2
  //-     | เบอร์ติดต่อ
  //-   button.transparent-button.w-50.py-2
  //-     i.fa.fa-map-marked-alt.mr-2
  //-     | แผนที่
</template>

<script>
import CustomerPicture from '@/components/customers/CustomerPicture.vue';

export default {
  props: [
    'data',
  ],
  methods: {
    // showPhone() {
    //   alert(`เบอร์ติดต่อ: \n${this.data.phone}`);
    // },
  },
  created() {
    console.log(this.data);
  },
  components: {
    CustomerPicture,
  },
};
</script>

<style lang="scss">
.customer-short-detail-button {
  width: 100%;
  border-bottom: 1px solid $border-color !important;
  padding: 0;
}
</style>
